import { render, staticRenderFns } from "./ThirdPartyDeliveryDetails.vue?vue&type=template&id=1096ae9d"
import script from "./ThirdPartyDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./ThirdPartyDeliveryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports